import { IconContainer } from './styles';

const DiscountOtherIcon = () => (
  <IconContainer
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="112"
    height="115"
    viewBox="0 0 112 115"
  >
    <path
      className={'background'}
      fill="#35C1CF"
      d="M7.1,54.8c-6.4-8.3-13.5-26.1,5.2-38.6C31,3.6,57.9-1.9,77.5,1.8C97.2,5.5,98.3,19,98.9,27
      c0.6,8-1.4,26.7-10.8,53.2c-9.4,26.5-18.2,26.4-18.2,26.4S52.5,114.2,7.1,54.8z"
    />
    <g>
      <path
        className={'foreground'}
        fill="#FFFFFF"
        d="M57.7,110.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0l-0.1,0l-0.2,0c-0.1,0-0.4,0-0.7,0
        c-0.8-0.1-1.6-0.3-2.6-0.6c-2-0.7-5.4-2.4-9.7-6.5c-7.6-7.1-19.6-23.1-34.1-58.8l0,0C8.6,41.2,6,33.5,8.1,25.2
        c2.1-8.2,8-14.1,17.7-17.5c21.5-7.5,49.6-6.7,68.4,1.9c7.9,3.6,12.8,8.7,14.5,15.1c1.4,5.5,0.3,11-0.5,14.7
        c-1.8,8.7-9.7,26.8-25.7,49.3c-8.7,12.2-15.1,17.3-19,19.5c-2.2,1.2-3.8,1.7-4.8,1.8C58.2,110,57.9,110.1,57.7,110.1z M57.1,109
        l0.2,0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0,1-0.1c0.9-0.1,2.4-0.5,4.5-1.7c3.8-2.1,10.1-7.2,18.7-19.2c15.9-22.4,23.7-40.3,25.6-48.9
        c0.8-3.6,1.9-9,0.5-14.2c-1.6-6.1-6.2-10.9-13.9-14.4C75.2,2.1,47.4,1.3,26.2,8.7C16.9,12,11.1,17.6,9.1,25.5
        c-2,8,0.5,15.5,1.6,18.3l0,0c14.4,35.5,26.3,51.4,33.8,58.4c4.2,3.9,7.4,5.6,9.3,6.2c1.1,0.4,1.8,0.5,2.3,0.5c0.2,0,0.4,0,0.5,0
        L57.1,109z"
      />
    </g>
  </IconContainer>
);

export default DiscountOtherIcon;
